import { defineMessages } from "react-intl";

export const messages = defineMessages({
    otherOrgsDisplayTitle: {
        id: "fastshift.dashboard.other-orgs-display.title",
        defaultMessage:
            "You’re viewing tickets associated with cloud organizations where you’re not an org admin",
        description: "Title for the other orgs display"
    },
    otherOrgsDisplayDescription: {
        id: "fastshift.dashboard.other-orgs-display.description",
        defaultMessage:
            "If you have access to a ticket, but not sufficient permissions in cloud, you’ll see it here without extra details about the organization.",
        description: "Description for the other orgs display"
    }
});
